import { useApi, useToggle } from "utils"
import { ValidationSchemaType } from "../utils"
import { ActionButton, Button, Modal } from "components"
import { Fragment } from "react"
import { FormProvider, useForm } from "react-hook-form"
import toast from "react-hot-toast"
import { FormSection } from "./FormSection"

export function Delete(props: {
    dataList: ValidationSchemaType,
    refetch: () => void
}) {
    const { isActive, toggle } = useToggle(false)

    return (
        <Fragment>
            <ActionButton.Delete className="join-item" onClick={toggle} />
            {isActive && <ModalSection dataList={props.dataList} toggle={toggle} refetch={props.refetch} />}
        </Fragment>
    )
}

function ModalSection(props: {
    toggle: () => void
    refetch: () => void,
    dataList: ValidationSchemaType
}) {
    const api = useApi()

    const methods = useForm<ValidationSchemaType>({
        defaultValues: props.dataList
    })

    const onSubmit = () => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.delete(`/groupasset/delete?mr_group_id=${props.dataList.mr_group_id}`),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {
                props.toggle()
                props.refetch()
            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <Modal isOpen title="DELETE GROUP ASSET" size="xl" closeModal={props.toggle}>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <FormSection isDetail action="DELETE" />
                    </Modal.Body>

                    <Modal.Footer className="flex justify-end">
                        <Button type="submit" color="error" loading={methods.formState.isSubmitting ? "true" : undefined}>Delete</Button>
                    </Modal.Footer>
                </form>
            </FormProvider>
        </Modal>
    )
}